const utilsReducer = (
    state = {
        initialParams: {},
        freeTrialPackage: false
    },
    action: {
        type: "SET_INITIAL_PARAMS" | "SET_FREE_TRIAL_PACKAGE"
        payload: any;
    }
) => {
    switch (action.type) {
        case "SET_INITIAL_PARAMS":
            return { ...state, initialParams: action.payload };
        case "SET_FREE_TRIAL_PACKAGE":
            return { ...state, freeTrialPackage: action.payload };
        default:
            return state;
    }
};

export default utilsReducer;